import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=7c5b507b&scoped=true"
import script from "./bottomBar.vue?vue&type=script&lang=js"
export * from "./bottomBar.vue?vue&type=script&lang=js"
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=7c5b507b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b507b",
  null
  
)

export default component.exports